import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this really for beginners?',
  a: 'Yes. We explain muscle mechanics simply so anyone can follow the recovery stages, from the inflammatory phase all the way to returning to full load.'
}, {
  q: 'Can I use this for old injuries?',
  a: 'Absolutely. The "Remodeling" phase is specifically designed to help with scar tissue and old "tweaks" that never went away.'
}, {
  q: 'Do I need a gym?',
  a: 'No. The system includes both home-based and gym-based progressions, so you can advance with bodyweight and basic household items or with full equipment.'
}, {
  q: 'Is there support?',
  a: 'Yes, you can contact the SIGMA SMART™ team at any time and we will help you with your specific case.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-38" data-mp="jorn1nnaysai">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-39" data-mp="1kngr5q09z2um">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-40" data-mp="1pls1e1uhffdd">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-41" data-mp="1arn4vewr7uzn">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-42" data-mp="11vxoxle2rstn" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-43" data-mp="16nyz91ron9h1">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-44" data-mp="wvt5bmhvehz7">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-45" data-mp="j0quqm22w4g2" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-46" data-mp="myojjnrxsoix" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-47" data-mp="2pnf0f7e67tqf">
                  <div className="overflow-hidden" data-id="element-48" data-mp="2fwkb1u5moe0r">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-49" data-mp="2fx3k0ldavs2n">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}